import { useEffect } from "react"
import { Link } from "react-router-dom"
import styles from "./LoginErrorBanner.module.css"

const MESSAGES: Record<string, string> = {
  invalid_state: "ログインセッションが無効です。もう一度お試しください。",
  google_failed: "Googleログインに失敗しました。しばらくしてからお試しください。",
  auth_not_configured: "ログイン機能の設定が完了していません。管理者にお問い合わせください。",
}

function messageFor(code: string): string {
  return MESSAGES[code] ?? `ログインに失敗しました（${code}）`
}

export function LoginErrorBanner() {
  const url = new URL(window.location.href)
  const loginError = url.searchParams.get("loginError")

  useEffect(() => {
    if (!loginError) return
    const current = new URL(window.location.href)
    current.searchParams.delete("loginError")
    window.history.replaceState(null, "", current.pathname + current.search + current.hash)
  }, [loginError])

  if (!loginError) return null

  return (
    <div className={styles.root} role="alert">
      <p className={styles.message}>{messageFor(loginError)}</p>
      <Link to="/" className={styles.link}>
        トップへ
      </Link>
    </div>
  )
}
